import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SortButton, Trigger } from '../Trigger';
import { useFilterStore } from '../useStore';
import { SearchInput } from './SearchInput';

const Main = styled.div`
  display: grid;
  gap: 16px;

  ${fromScreen(768)} {
    grid-template-columns: 1fr max-content;
    align-items: center;
  }
  ${fromScreen(1024)} {
    display: none;
  }
  .actions {
    display: flex;
    flex-wrap: wrap;
    margin: -9px -8px;
    > * {
      margin: 9px 8px;
    }
  }
`;

interface ObservedTabletSearchInputProps {
  searchPlaceholder?: string;
}

export const ObservedTabletSearchInput = observer(
  ({ searchPlaceholder }: ObservedTabletSearchInputProps) => {
    const filterStore = useFilterStore();

    if (!filterStore) {
      return null;
    }

    return (
      <Main className="observed-table-search-input">
        <SearchInput
          disabled={filterStore.isFilterOnly}
          placeholder={searchPlaceholder || 'Nhập từ khóa bạn cần tìm'}
          defaultValue={filterStore.search}
          onSearch={(dto) => {
            filterStore.update(dto);
          }}
        />
        <div className="actions">
          <SortButton />
          <Trigger />
        </div>
      </Main>
    );
  }
);
